import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FoodIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FoodGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_46_1920)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.06637 1.26409C3.64517 1.26409 3.29957 1.60969 3.29957 2.03089C3.29957 2.45209 3.64517 2.79769 4.06637 2.79769H5.21117H9.13157C11.0756 2.79769 12.7496 3.94249 13.5272 5.60569H14.888C15.5684 5.60569 16.184 5.89729 16.616 6.36169C17.048 5.89729 17.6636 5.60569 18.344 5.60569H20.5256V7.73329C20.5256 8.13289 20.4284 8.50009 20.2556 8.82409H22.07V10.1741C22.07 14.8289 18.3008 18.5981 13.646 18.5981H8.89397C4.23917 18.5981 0.469971 14.8289 0.469971 10.1741V8.82409H3.15917C3.37517 7.59289 4.20677 6.57769 5.32997 6.10249C4.86557 5.58409 4.57397 4.89289 4.57397 4.13689V4.06129H4.06637C2.94317 4.06129 2.03597 3.15409 2.03597 2.03089C2.03597 0.907688 2.94317 0.000488281 4.06637 0.000488281H8.53757V1.26409H4.06637ZM7.52237 5.81089H7.67357C7.74917 5.81089 7.83557 5.81089 7.91117 5.81089V4.06129H5.84837V4.13689C5.84837 5.06569 6.59357 5.81089 7.52237 5.81089ZM9.17477 4.07209V6.14569C10.2548 6.63169 11.054 7.63609 11.2592 8.83489H12.7064V7.64689C12.7064 5.68129 11.1296 4.09369 9.17477 4.07209ZM17.2532 8.82409H18.1604C18.7652 8.82409 19.2512 8.33809 19.2512 7.73329V6.86929H18.344C17.7392 6.86929 17.2532 7.35529 17.2532 7.96009V8.82409ZM15.9788 7.96009V8.82409H15.0716C14.4668 8.82409 13.9808 8.33809 13.9808 7.73329V6.86929H14.888C15.4928 6.86929 15.9788 7.35529 15.9788 7.96009ZM9.96317 8.82409C9.68237 7.81969 8.76437 7.07449 7.67357 7.07449H6.75557C5.66477 7.07449 4.73597 7.80889 4.46597 8.82409H9.97397H9.96317ZM1.73357 10.0877V10.1741C1.73357 10.5737 1.76597 10.9733 1.83077 11.3513H20.7092C20.774 10.9625 20.8064 10.5737 20.8064 10.1741V10.0877H1.73357ZM20.3744 12.6257H2.16557C3.15917 15.3797 5.80517 17.3345 8.89397 17.3345H13.646C16.7456 17.3345 19.3808 15.3689 20.3744 12.6257Z"
          fill="#696969"
        />
      </g>
      <defs>
        <clipPath id="clip0_46_1920">
          <rect
            width="21.6"
            height="18.5976"
            fill="white"
            transform="translate(0.469971)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FoodIcon;
